'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var reactJss = require('react-jss');
var classNames = _interopDefault(require('classnames'));
var DOMPurify = _interopDefault(require('dompurify'));

const generateUniqueString = function () {
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.replace(/\s/g, '') + '_' + Math.random().toString(36).substr(2, 9);
};
const isTouchDevice = () => {
  // If Modernizr set feature-detection class
  if (document.documentElement.classList.contains('touchevents')) {
    return true;
  }
  // Taken from Modernizr source before deprecation.
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  const mq = function (query) {
    return window.matchMedia(query).matches;
  };
  if ('ontouchstart' in window || window['DocumentTouch'] && document instanceof window['DocumentTouch']) {
    return true;
  }
  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
};

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

var sharedStyles = {
  screenReaderOnly: {
    position: 'absolute',
    clip: 'rect(1px 1px 1px 1px)',
    width: 1,
    height: 1,
    overflow: 'hidden'
  },
  defaultShadowHighlighting: {
    outline: 'none',
    '-webkit-appearance': 'none',
    boxShadow: 'inset 0 0 0 1px #d8d8d9, 0 0 7px #7c7c7c'
  },
  formControl: {
    width: '100%',
    border: 'none',
    background: '#f4f4f4',
    borderRadius: 2,
    height: 36,
    padding: [6, 16],
    fontWeight: 400,
    fontFamily: 'inherit',
    fontSize: 14,
    lineHeight: '24px',
    color: '#686868',
    boxSizing: 'border-box',
    '@media only screen and (-webkit-min-device-pixel-ratio:0)': {
      fontSize: 16
    },
    '@media only screen and (max-width: 1200px)': {
      paddingLeft: 12,
      paddingRight: 12
    },
    '@media only screen and (max-width: 991px)': {
      paddingLeft: 10,
      paddingRight: 10
    },
    '@media only screen and (max-width: 767px)': {
      paddingLeft: 8,
      paddingRight: 8
    }
  },
  ctaButton: {
    position: 'relative',
    display: 'inline-block',
    minWidth: 120,
    minHeight: 48,
    padding: [5, 30],
    boxSizing: 'border-box',
    border: '1px solid #e2000f',
    borderRadius: 4,
    backgroundColor: '#e2000f',
    color: '#fff',
    fontSize: 18,
    fontWeight: 600,
    lineHeight: '24px',
    textAlign: 'center',
    letterSpacing: '0.03em',
    verticalAlign: 'middle',
    touchAction: 'manipulation',
    transition: 'all .3s ease',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#b5000c',
      borderColor: '#b5000c'
    },
    '&[disabled]': {
      border: '1px solid #f5a6ab',
      backgroundColor: '#f5a6ab',
      cursor: 'default'
    }
  },
  errorMessage: {
    fontSize: 14,
    lineHeight: '24px',
    color: '#b6000f'
  },
  webexFontFamily: 'myriad-pro, Geneva, Tahoma, sans-serif'
};

var styles = {
  fieldWrapper: {
    position: 'relative',
    marginBottom: 24,
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
    color: '#686868',
    fontFamily: sharedStyles.webexFontFamily,
    '& input': {
      position: 'absolute',
      opacity: 0,
      zIndex: -1,
      '&:focus + $visibleCheckbox': _objectSpread2({}, sharedStyles.defaultShadowHighlighting)
    },
    '& label': {
      paddingLeft: 23,
      cursor: 'pointer'
    },
    '&:not($disabled):hover $visibleCheckbox:not($checked)': {
      borderColor: '#e2000f',
      '&+ label': {
        color: '#e2000f'
      }
    },
    '&:hover $visibleCheckbox': {
      '&:before, &:after': {
        display: 'block'
      }
    }
  },
  visibleCheckbox: {
    position: 'absolute',
    height: 13,
    width: 13,
    marginTop: 5,
    marginRight: 10,
    border: '1px solid #686868',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    borderRadius: 2,
    pointerEvents: 'none',
    '&:before, &:after': {
      display: 'none',
      content: '""',
      position: 'absolute',
      width: 10,
      height: 1.5,
      backgroundColor: '#fff',
      top: 5,
      left: 0
    },
    '&:before': {
      transform: 'rotate(45deg)'
    },
    '&:after': {
      transform: 'rotate(-45deg)'
    }
  },
  checked: {
    background: '#303030'
  },
  disabled: {
    opacity: 0.3
  },
  screenReaderOnly: sharedStyles.screenReaderOnly,
  errorMessage: sharedStyles.errorMessage
};

const useStyles = reactJss.createUseStyles(styles);
const ConsentField = React.memo(props => {
  const {
    label,
    value: isSelected = false,
    disabled,
    setValue,
    error,
    errorMessage,
    controlRef
  } = props;
  const labelId = React.useMemo(() => generateUniqueString('label'), []);
  const inputId = React.useMemo(() => generateUniqueString('input'), []);
  const classes = useStyles(props);
  return React__default.createElement("div", {
    className: classNames('fs-consent-field-wrapper', classes.fieldWrapper, {
      [classes.disabled]: disabled
    }, {
      'fs-control-disabled': disabled
    })
  }, React__default.createElement("input", {
    id: inputId,
    ref: controlRef,
    "aria-disabled": disabled,
    "aria-labelledby": labelId,
    type: "checkbox",
    onChange: e => setValue(e.target.checked),
    checked: isSelected,
    disabled: disabled
  }), React__default.createElement("span", {
    className: classNames('fs-visible-checkbox-control', classes.visibleCheckbox, {
      [classes.checked]: isSelected,
      'fs-visible-checkbox-checked': isSelected
    })
  }), React__default.createElement("label", {
    id: labelId,
    htmlFor: inputId
  }, label, error && React__default.createElement("span", {
    className: classNames('fs-screen-reader-only', classes.screenReaderOnly)
  }, errorMessage)), error && React__default.createElement("div", {
    className: classNames('fs-field-error-message', classes.errorMessage)
  }, errorMessage));
});

const ArrowIcon = props => React__default.createElement("svg", _objectSpread2({
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 768 768",
  focusable: "false"
}, props), React__default.createElement("path", {
  fill: "#686868",
  d: "M604 320c-8.836 0.002-16.834 3.585-22.624 9.376l-169.376 169.376-169.376-169.376c-5.749-5.558-13.59-8.983-22.231-8.983-17.673 0-32 14.327-32 32 0 8.641 3.425 16.482 8.991 22.24l191.991 191.991c5.791 5.789 13.789 9.369 22.624 9.369s16.833-3.58 22.624-9.369l192-192c5.789-5.791 9.369-13.789 9.369-22.624 0-17.671-14.323-31.996-31.993-32z"
}));

const SpinnerIcon = props => React__default.createElement("svg", _objectSpread2({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "24px",
  height: "24px",
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid"
}, props), React__default.createElement("circle", {
  cx: "50",
  cy: "50",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "6",
  r: "24",
  strokeDasharray: "113.09733552923255 39.69911184307752"
}));

const InfoIcon = props => React__default.createElement("svg", _objectSpread2({
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  viewBox: "0 0 768 768"
}, props), React__default.createElement("path", {
  fill: "#969696",
  d: "M415.5 288v-64.5h-63v64.5h63zM415.5 544.5v-192h-63v192h63zM384 64.5q132 0 225.75 93.75t93.75 225.75-93.75 225.75-225.75 93.75-225.75-93.75-93.75-225.75 93.75-225.75 225.75-93.75z"
}));

var styles$1 = {
  hint: {
    position: 'absolute',
    zIndex: 5,
    top: 20,
    left: 0,
    width: '70vw',
    backgroundColor: '#fff',
    boxShadow: '0 0 15px #d8d8d9',
    padding: [18, 20],
    boxSizing: 'border-box',
    fontSize: 13,
    maxWidth: 165,
    color: '#7c7c7c',
    lineHeight: '18px'
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 35,
    height: 35,
    backgroundColor: 'transparent',
    border: '1px solid transparent',
    padding: 0,
    zIndex: 1,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      width: 15,
      height: 2,
      backgroundColor: '#e2000f',
      top: 18,
      left: 9
    },
    '&:before': {
      transform: 'rotate(45deg)'
    },
    '&:after': {
      transform: 'rotate(-45deg)'
    }
  },
  touchActive: {
    paddingRight: 25
  },
  leftSided: {
    right: 0,
    left: 'auto'
  }
};

const useStyles$1 = reactJss.createUseStyles(styles$1);
const Hint = props => {
  const {
    text,
    isTouchActivated,
    closeHandler
  } = props;
  const [isLeftSided, setIsLeftSided] = React.useState(false);
  const hintRef = React.useRef(null);
  const classes = useStyles$1(props);
  React.useLayoutEffect(() => {
    const domRect = hintRef.current && hintRef.current.getBoundingClientRect();
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (domRect && domRect.right > viewportWidth) {
      setIsLeftSided(true);
    }
  }, []);
  return React__default.createElement("div", {
    ref: hintRef,
    className: classNames('fs-hint', classes.hint, {
      'fs-hint-touch': isTouchActivated,
      [classes.touchActive]: isTouchActivated,
      'fs-hint-left-sided': isLeftSided,
      [classes.leftSided]: isLeftSided
    })
  }, isTouchActivated && React__default.createElement("button", {
    className: classNames('fs-close-button', classes.closeButton),
    onClick: closeHandler
  }), text);
};

var styles$2 = {
  screenReaderOnly: sharedStyles.screenReaderOnly,
  activeIcon: {
    '& path': {
      fill: '#444c56'
    }
  },
  disabledIcon: {
    '& path': {
      opacity: '0.3'
    }
  }
};

const useStyles$2 = reactJss.createUseStyles(styles$2);
const hasTouch = isTouchDevice();
function useAddOutsideClickHandling(hintWrapperRef, hide) {
  React.useEffect(() => {
    if (!hasTouch) return;
    function handleClickOutside(event) {
      if (hintWrapperRef.current && !hintWrapperRef.current.contains(event.target)) {
        hide();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [hintWrapperRef, hide]);
}
const HintOverlay = props => {
  const {
    hint,
    disabled,
    children
  } = props;
  const [isOpened, setIsOpened] = React.useState(false);
  const classes = useStyles$2(props);
  const hintWrapperRef = React.useRef(null);
  const a11yHint = React.useRef(null);
  const toggle = React.useCallback(() => {
    if (!disabled) {
      setIsOpened(currentIsOpen => !currentIsOpen);
    }
  }, [disabled]);
  const hide = React.useCallback(() => {
    setIsOpened(false);
    a11yHint.current.innerHTML = '';
  }, []);
  const show = React.useCallback(() => {
    if (!disabled) {
      setIsOpened(true);
      a11yHint.current.innerHTML = hint;
    }
  }, [disabled, hint]);
  const childEvents = hasTouch ? {
    onClick: toggle
  } : {
    onMouseEnter: show,
    onMouseLeave: hide
  };
  useAddOutsideClickHandling(hintWrapperRef, hide);
  return React__default.createElement("div", {
    ref: hintWrapperRef
  }, React__default.cloneElement(children, _objectSpread2(_objectSpread2({}, childEvents), {}, {
    className: classNames({
      'fs-active-info-icon': isOpened,
      'fs-disabled-info-icon': disabled,
      [classes.disabledIcon]: disabled,
      [classes.activeIcon]: isOpened
    })
  })), isOpened && React__default.createElement(Hint, {
    text: hint,
    isTouchActivated: hasTouch,
    closeHandler: hide
  }), React__default.createElement("div", {
    className: classNames('fs-screen-reader-only', classes.screenReaderOnly),
    ref: a11yHint,
    "aria-live": "assertive",
    "aria-atomic": "true",
    role: "alert"
  }));
};

var styles$3 = {
  wrapper: {
    position: 'relative',
    height: 24,
    cursor: 'default'
  },
  label: {
    display: 'inline-block',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
    color: '#686868',
    maxWidth: 'calc(100% - 30px)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  requiredSymbol: {
    color: '#b6000f',
    verticalAlign: 'top'
  },
  infoIcon: {
    position: 'absolute',
    display: 'inline-block',
    top: 3,
    marginLeft: 2,
    paddingTop: 1
  },
  disabled: {
    opacity: 0.3
  },
  screenReaderOnly: sharedStyles.screenReaderOnly
};

const useStyles$3 = reactJss.createUseStyles(styles$3);
const Label = React.memo(props => {
  const {
    title,
    required,
    hint,
    disabled,
    id,
    htmlFor,
    errorMessage,
    hasError
  } = props;
  const classes = useStyles$3(props);
  return React__default.createElement("div", {
    className: classNames('fs-label-wrapper', classes.wrapper)
  }, React__default.createElement("label", {
    id: id,
    htmlFor: htmlFor,
    className: classNames('fs-label', classes.label, {
      'fs-control-disabled': disabled,
      [classes.disabled]: disabled
    }),
    "aria-hidden": disabled
  }, title, React__default.createElement("span", {
    "aria-hidden": disabled,
    className: classNames('fs-required-symbol', classes.requiredSymbol)
  }, title && required ? ' *' : null, "\u00A0"), hasError && errorMessage && React__default.createElement("span", {
    className: classNames('fs-screen-reader-only', classes.screenReaderOnly)
  }, errorMessage), hint && React__default.createElement("span", {
    className: classNames('fs-screen-reader-only', classes.screenReaderOnly)
  }, hint)), hint && React__default.createElement("div", {
    className: classNames('fs-info-icon', classes.infoIcon)
  }, React__default.createElement(HintOverlay, {
    hint: hint,
    disabled: disabled
  }, React__default.createElement(InfoIcon, null))));
});

const keyFrames = {
  spin: {
    '@keyframes spin': {
      from: {
        transform: 'rotate(0deg)'
      },
      to: {
        transform: 'rotate(360deg)'
      }
    }
  }
};

var styles$4 = _objectSpread2(_objectSpread2({}, keyFrames.spin), {}, {
  fieldWrapper: {
    fontFamily: sharedStyles.webexFontFamily
  },
  selectWrapper: {
    position: 'relative',
    marginBottom: 12
  },
  fieldError: {
    marginBottom: 0,
    '& $formControl': {
      border: '1px solid #e2000f'
    }
  },
  formControl: _objectSpread2({
    position: 'relative'
  }, sharedStyles.formControl),
  select: {
    position: 'absolute',
    width: 'max-content',
    minWidth: '100%',
    height: 36,
    top: 0,
    left: 0,
    opacity: 0,
    zIndex: 1,
    paddingLeft: 16,
    paddingRight: 1,
    fontFamily: 'inherit',
    fontSize: 'inherit',
    '-webkit-appearance': 'none',
    '@media only screen and (max-width: 991px)': {
      width: '100%'
    },
    '&:focus, &:active': {
      outline: 'none',
      '& ~ label:after': _objectSpread2({
        content: '""',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }, sharedStyles.defaultShadowHighlighting)
    }
  },
  selectedItem: {
    display: 'inline-block',
    maxHeight: 24,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: 'calc(100% - 34px)'
  },
  placeholder: {
    color: '#969696'
  },
  endAdornment: {
    maxHeight: 24,
    position: 'absolute',
    top: 5,
    right: 4,
    display: 'flex'
  },
  loadingIndicator: {
    width: 24
  },
  spinner: {
    width: 28,
    height: 28,
    verticalAlign: 'middle',
    animation: '$spin 1s linear infinite'
  },
  disabled: {
    opacity: 0.3
  },
  errorMessage: sharedStyles.errorMessage
});

const useStyles$4 = reactJss.createUseStyles(styles$4);
const getOptionTitleByValue = (options, value) => {
  const optionsLength = options.length;
  for (let i = 0; i < optionsLength; i++) {
    const currentOption = options[i];
    if (currentOption.value === value) {
      return currentOption.title;
    }
  }
  return '';
};
const DropdownField = React.memo(props => {
  const {
    name,
    placeholder,
    label,
    options,
    hint,
    setValue,
    value = '',
    error,
    errorMessage,
    disabled,
    required,
    controlRef,
    isLoading
  } = props;
  const classes = useStyles$4(props);
  const extendedOptions = React.useMemo(() => [{
    title: placeholder || label || name,
    value: '',
    hidden: true
  }, ...options], [label, placeholder, name, options]);
  const selectedOptionTitle = React.useMemo(() => getOptionTitleByValue(extendedOptions, value), [extendedOptions, value]);
  const isPlaceholderItemVisible = React.useMemo(() => selectedOptionTitle === placeholder || !selectedOptionTitle, [selectedOptionTitle, placeholder]);
  const labelId = React.useMemo(() => generateUniqueString('label'), []);
  const inputId = React.useMemo(() => generateUniqueString('input'), []);
  const handleOnChange = React.useCallback(e => {
    setValue(e.target.value);
  }, [setValue]);
  return React__default.createElement("div", {
    className: classNames('fs-dropdown-field-wrapper', classes.fieldWrapper)
  }, Boolean(label) ? React__default.createElement(Label, {
    id: labelId,
    htmlFor: inputId,
    title: label,
    errorMessage: errorMessage,
    hasError: error,
    required: required,
    disabled: disabled,
    hint: hint
  }) : null, React__default.createElement("div", {
    className: classNames('fs-select-wrapper', classes.selectWrapper, {
      'fs-field-error': error,
      [classes.fieldError]: error
    })
  }, React__default.createElement("div", {
    className: classNames('fs-form-control', classes.formControl, {
      'fs-control-disabled': disabled,
      [classes.disabled]: disabled
    }),
    "aria-haspopup": "listbox"
  }, React__default.createElement("select", {
    id: inputId,
    ref: controlRef,
    className: classes.select,
    onChange: handleOnChange,
    name: name,
    value: value,
    disabled: disabled || isLoading,
    "aria-labelledby": labelId,
    role: "listbox",
    "aria-disabled": disabled
  }, isLoading ? null : extendedOptions.map(option => React__default.createElement("option", {
    key: option.value,
    value: option.value,
    hidden: option.hidden,
    disabled: option.hidden,
    role: "option"
  }, option.title))), React__default.createElement("label", {
    className: classNames('fs-select-selected-item', classes.selectedItem, {
      'fs-placeholder-style': isPlaceholderItemVisible,
      [classes.placeholder]: isPlaceholderItemVisible
    })
  }, selectedOptionTitle || placeholder), React__default.createElement("div", {
    className: classNames('fs-select-end-adornment', classes.endAdornment)
  }, isLoading && React__default.createElement("span", {
    className: classNames('fs-select-loading-indicator', classes.loadingIndicator)
  }, React__default.createElement(SpinnerIcon, {
    className: classNames('fs-select-loading-indicator-spinner', classes.spinner)
  })), React__default.createElement("span", {
    className: classNames('fs-arrow-icon')
  }, React__default.createElement(ArrowIcon, null)))), error && React__default.createElement("span", {
    className: classNames('fs-field-error-message', classes.errorMessage)
  }, errorMessage, "\u00A0")));
});

var styles$5 = {
  link: _objectSpread2(_objectSpread2({}, sharedStyles.ctaButton), {}, {
    fontFamily: sharedStyles.webexFontFamily,
    textDecoration: 'none',
    paddingTop: 12,
    paddingBottom: 12
  })
};

const useStyles$5 = reactJss.createUseStyles(styles$5);
const LinkButton = React.memo(props => {
  const {
    label,
    url,
    newWindow = false,
    onClick
  } = props;
  const classes = useStyles$5(props);
  return React__default.createElement("a", {
    className: classNames('fs-link-button', classes.link),
    href: url,
    target: newWindow ? '_blank' : null,
    onClick: onClick,
    rel: "noreferrer"
  }, label);
});

var styles$6 = {
  wrapper: {
    marginBottom: 12,
    letterSpacing: '.01em',
    fontFamily: sharedStyles.webexFontFamily,
    '& a, & a:focus, & a:visited': {
      color: '#e2000f',
      borderBottom: '1px solid #e2000f',
      textDecoration: 'none'
    },
    '& a:hover': {
      color: '#b6000f',
      borderBottomColor: '#b6000f'
    },
    '& p': {
      margin: 0
    }
  },
  disabled: {
    opacity: 0.3
  }
};

const useStyles$6 = reactJss.createUseStyles(styles$6);
const PlainText = React.memo(props => {
  const {
    label,
    disabled
  } = props;
  const classes = useStyles$6(props);
  return React__default.createElement("div", {
    className: classNames('fs-text-wrapper', classes.wrapper, {
      [classes.disabled]: disabled
    }, {
      'fs-control-disabled': disabled
    }),
    "aria-hidden": disabled,
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(label, {
        ADD_ATTR: ['target']
      })
    }
  });
});

var styles$7 = {
  button: _objectSpread2(_objectSpread2({}, sharedStyles.ctaButton), {}, {
    fontFamily: sharedStyles.webexFontFamily
  }),
  buttonContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  '@keyframes spin': {
    from: {
      transform: 'rotate(0deg)'
    },
    to: {
      transform: 'rotate(360deg)'
    }
  },
  spinnerIcon: {
    marginRight: 10,
    animation: '$spin 1s linear infinite'
  }
};

const useStyles$7 = reactJss.createUseStyles(styles$7);
const SubmitButton = React.memo(props => {
  const {
    label,
    processingLabel,
    disabled,
    isFormSubmitting
  } = props;
  const classes = useStyles$7(props);
  return React__default.createElement("button", {
    className: classNames('fs-submit-button', classes.button),
    disabled: disabled,
    "aria-hidden": disabled,
    type: "submit"
  }, React__default.createElement("span", {
    className: classNames('fs-submit-button-content', classes.buttonContent)
  }, isFormSubmitting && React__default.createElement("svg", {
    className: classes.spinnerIcon,
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("path", {
    fill: "#fff",
    d: "M10.5,21 C4.71053333,21 0,16.2894667 0,10.5 C0,4.71053333 4.71053333,0 10.5,0 C10.8864,0 11.2,0.3136 11.2,0.7 C11.2,1.0864 10.8864,1.4 10.5,1.4 C5.4824,1.4 1.4,5.4824 1.4,10.5 C1.4,15.5176 5.4824,19.6 10.5,19.6 C15.5176,19.6 19.6,15.5176 19.6,10.5 C19.6,10.1136 19.9136,9.8 20.3,9.8 C20.6864,9.8 21,10.1136 21,10.5 C21,16.2894667 16.2894667,21 10.5,21",
    id: "path-1"
  })), React__default.createElement("span", {
    className: "fs-submit-button-text"
  }, isFormSubmitting ? processingLabel : label)));
});

var styles$8 = {
  fieldWrapper: {
    fontFamily: sharedStyles.webexFontFamily
  },
  textarea: _objectSpread2(_objectSpread2({}, sharedStyles.formControl), {}, {
    resize: 'none',
    height: 108,
    width: '100%',
    overflow: 'auto',
    '&:not($disabled):focus': _objectSpread2({}, sharedStyles.defaultShadowHighlighting),
    '@media only screen and (max-width: 991px)': {
      height: 120
    }
  }),
  textareaWrapper: {
    marginBottom: 12
  },
  textareaError: {
    marginBottom: 0,
    '& $textarea': {
      border: '1px solid #e2000f'
    }
  },
  disabled: {
    opacity: 0.3
  },
  errorMessage: sharedStyles.errorMessage
};

const useStyles$8 = reactJss.createUseStyles(styles$8);
const TextAreaField = React.memo(props => {
  const {
    name,
    placeholder,
    hint,
    label,
    value,
    error,
    errorMessage,
    setValue,
    required,
    disabled,
    controlRef
  } = props;
  const labelId = React.useMemo(() => generateUniqueString('label'), []);
  const inputId = React.useMemo(() => generateUniqueString('input'), []);
  const classes = useStyles$8(props);
  return React__default.createElement("div", {
    className: classNames('fs-textarea-field-wrapper', classes.fieldWrapper)
  }, label && React__default.createElement(Label, {
    id: labelId,
    htmlFor: inputId,
    title: label,
    errorMessage: errorMessage,
    hasError: error,
    required: required,
    disabled: disabled,
    hint: hint
  }), React__default.createElement("div", {
    className: classNames('fs-textarea-wrapper', classes.textareaWrapper, {
      'fs-textarea-error': error,
      [classes.textareaError]: error
    })
  }, React__default.createElement("textarea", {
    id: inputId,
    ref: controlRef,
    className: classNames('fs-form-control', classes.textarea, {
      [classes.disabled]: disabled,
      'fs-form-control-disabled': disabled
    }),
    placeholder: placeholder,
    name: name,
    onChange: e => setValue(e.target.value),
    value: value,
    disabled: disabled,
    "aria-labelledby": labelId,
    "aria-disabled": disabled
  }), error && React__default.createElement("span", {
    className: classNames('fs-field-error-message', classes.errorMessage)
  }, errorMessage, "\u00A0")));
});

var styles$9 = {
  fieldWrapper: {
    fontFamily: sharedStyles.webexFontFamily
  },
  inputWrapper: {
    marginBottom: 12
  },
  input: _objectSpread2(_objectSpread2({}, sharedStyles.formControl), {}, {
    '&:focus': _objectSpread2({}, sharedStyles.defaultShadowHighlighting)
  }),
  inputError: {
    marginBottom: 0,
    '& $input': {
      border: '1px solid #e2000f'
    }
  },
  disabled: {
    cursor: 'default',
    opacity: 0.3
  },
  errorMessage: sharedStyles.errorMessage
};

const useStyles$9 = reactJss.createUseStyles(styles$9);
const TextField = React.memo(props => {
  const {
    name,
    placeholder,
    hint,
    setValue,
    label,
    required,
    disabled,
    error,
    errorMessage,
    value = '',
    type,
    controlRef
  } = props;
  const labelId = React.useMemo(() => generateUniqueString('label'), []);
  const inputId = React.useMemo(() => generateUniqueString('input'), []);
  const classes = useStyles$9(props);
  return React__default.createElement("div", {
    className: classNames('fs-input-field-wrapper', classes.fieldWrapper)
  }, !!label && React__default.createElement(Label, {
    id: labelId,
    htmlFor: inputId,
    title: label,
    errorMessage: errorMessage,
    hasError: error,
    required: required,
    disabled: disabled,
    hint: hint
  }), React__default.createElement("div", {
    className: classNames('fs-input-wrapper', classes.inputWrapper, {
      'fs-input-error': error,
      [classes.inputError]: error
    })
  }, React__default.createElement("input", {
    id: inputId,
    ref: controlRef,
    type: type === 'Phone' ? 'tel' : null,
    className: classNames('fs-form-control', classes.input, {
      [classes.disabled]: disabled,
      'fs-form-control-disabled': disabled
    }),
    placeholder: placeholder,
    name: name,
    onChange: e => setValue(e.target.value),
    value: value,
    disabled: disabled,
    "aria-required": required,
    "aria-labelledby": labelId,
    "aria-disabled": disabled
  }), error && React__default.createElement("span", {
    className: classNames('fs-field-error-message', classes.errorMessage)
  }, errorMessage, "\u00A0")));
});

const fieldComponentMap = {
  Text: TextField,
  Dropdown: DropdownField,
  Phone: TextField,
  TextArea: TextAreaField,
  Consent: ConsentField,
  Submit: SubmitButton,
  LinkButton: LinkButton,
  PlainText: PlainText
};

exports.fieldComponentMap = fieldComponentMap;
//# sourceMappingURL=index.js.map
